// removed by extract-text-webpack-plugin
module.exports = {"FAQList":"_3wggmItE03tOIE0EYEaTqQ","FAQItem":"_3aCyQzM_njre6CIoogVX0Z","AuthorImage":"_1sRy55juMfYrIgryADeNRp"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Category/style.css
// module id = 817
// module chunks = 0